import React, { useEffect, useState } from 'react';
import { notificationTypes } from '../../constants';
import { useAppDispatch } from '../../hooks';
import { notificationActions } from '../../redux/actions';
import { Notification as NotificationInterface } from '../../types';
import {
  NotificationItem,
  IconWrapper,
  ContentWrapper,
  Title,
  Message,
  CloseButton,
  ProgressBar,
} from './Notification.styled';

interface Props {
  notification: NotificationInterface;
}

const Notification: React.FC<Props> = ({ notification }) => {
  const dispatch = useAppDispatch();
  const [isExiting, setIsExiting] = useState(false);
  const duration = 4000; // 4 seconds

  useEffect(() => {
    const timer = setTimeout(() => {
      handleClose();
    }, duration);

    return () => clearTimeout(timer);
  }, [notification.id]);

  const handleClose = () => {
    setIsExiting(true);
    setTimeout(() => {
      dispatch(notificationActions.removeNotification(notification.id));
    }, 300); // Match animation duration
  };

  const getIcon = () => {
    switch (notification.notiType) {
      case notificationTypes.SUCCESS:
        return '✓';
      case notificationTypes.DANGER:
        return '✕';
      default:
        return 'ℹ';
    }
  };

  const getTitle = () => {
    switch (notification.notiType) {
      case notificationTypes.SUCCESS:
        return 'Thành công!';
      case notificationTypes.DANGER:
        return 'Lỗi!';
      default:
        return 'Thông báo';
    }
  };

  return (
    <NotificationItem type={notification.notiType} isExiting={isExiting}>
      <IconWrapper type={notification.notiType}>
        {getIcon()}
      </IconWrapper>
      <ContentWrapper>
        <Title>{getTitle()}</Title>
        <Message>{notification.message}</Message>
      </ContentWrapper>
      <CloseButton onClick={handleClose}>
        ×
      </CloseButton>
      <ProgressBar duration={duration} />
    </NotificationItem>
  );
};

export default Notification;
